import { useCallback } from "preact/hooks";
import { Navigation } from "../../components";
import {
  useSkinStore,
  SkinPreset,
  resolvePreviewUrls,
} from "../../store/skinStore";
import css from "./Skins.module.scss";

const GAME_TYPE: GameType = import.meta.env.VITE_GAME_TYPE || "twins";

export const Skins = () => {
  const { skinIds, setSkin, getAvailableSkins } = useSkinStore();

  const currentSkinId = skinIds[GAME_TYPE];
  const availableSkins = getAvailableSkins(GAME_TYPE);

  const handleSkinSelect = useCallback(
    (skin: SkinPreset) => setSkin(GAME_TYPE, skin.id),
    [setSkin]
  );

  return (
    <div className={css.wrapper}>
      <Navigation title="SKINS" />
      <div className={css.container}>
        {availableSkins.map((skin) => {
          const isActive = currentSkinId === skin.id;
          return (
            <button
              key={skin.id}
              className={`${css.card} ${isActive ? css.active : ""}`}
              onClick={() => handleSkinSelect(skin)}
            >
              <div className={css.imageWrapper}>
                {(() => {
                  const urls = resolvePreviewUrls(skin.preview);
                  return (
                    <picture>
                      <source type="image/webp" srcSet={urls.webp} />
                      <img
                        src={urls.png}
                        className={css.image}
                        alt={skin.name}
                      />
                    </picture>
                  );
                })()}
              </div>
              <span className={css.name}>{skin.name}</span>
              <span className={css.description}>{skin.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
